import { normalizeReferralCode } from "@/lib/referral/referral-code-cookie"

export type ReferralSignupSource = "url" | "local_storage" | "cookie"

/**
 * Hierarquia na conclusão do cadastro (regulamento §5.1):
 * 1. parâmetro `ref` na URL da página
 * 2. armazenamento local do navegador
 * 3. cookie
 */
export function resolveReferralCodeAtSignup(input: {
  urlCode: string | null | undefined
  localStorageCode: string | null | undefined
  cookieCode: string | null | undefined
}): { code: string | null; source: ReferralSignupSource | null } {
  const url = normalizeReferralCode(input.urlCode)
  if (url) return { code: url, source: "url" }

  const ls = normalizeReferralCode(input.localStorageCode)
  if (ls) return { code: ls, source: "local_storage" }

  const cookie = normalizeReferralCode(input.cookieCode)
  if (cookie) return { code: cookie, source: "cookie" }

  return { code: null, source: null }
}

/** Com `ref` na URL no signup, a janela de atribuição conta a partir desse momento. */
export function resolveReferralCapturedAtAtSignup(input: {
  hasUrlCode: boolean
  localStorageCapturedAt: string | null | undefined
  now?: Date
}): string | null {
  if (input.hasUrlCode) {
    return (input.now ?? new Date()).toISOString()
  }
  const raw = input.localStorageCapturedAt?.trim()
  return raw || null
}
